/**
 * FILE: apps/hub/src/hooks/themeContext.ts
 * PURPOSE: Shared theme context and types for ThemeProvider / useTheme.
 */

import { createContext } from 'react'

export type Theme = 'light' | 'dark' | 'system'

export interface ThemeContextValue {
  theme: Theme
  resolvedTheme: 'light' | 'dark'
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)
